/**
 * Публичная часть сайта
 */
import 'bootstrap';

// Глобальное подключение lodash, чтобы vue.mixins.js его увидел
import _ from 'lodash';
window._ = _;

// Роуты публичной части сайта
import guestRoutes from '../../js/routes-guest.json';
window.guestRoutes;

// Глобальная инициализация Fancybox
import './fancybox-inject.js';

// Поведение и внешний вид скролла
import './custom-scroll.js'

// Инициализация слайдера для блока с отзывами
import './reviews-swiper.js'

// Обработчики событий jQuery
import './interactive.js';
